import clsx from 'clsx';
import { ReactNode, useState } from 'react';
import styles from './PlainTabControl.module.css';

interface TabPage {
  title: string;
  subtitle?: string;
  content: ReactNode;
}

export interface Props {
  pages: TabPage[];
  initialActiveIndex?: number;
  centerButtonText?: boolean;
  reduceButtonSpacing?: boolean;
}

const PlainTabControl = (props: Props) => {
  const [activeTabIndex, setActiveTabIndex] = useState(
    props.initialActiveIndex || 0,
  );

  const tabPageCornerClassName =
    activeTabIndex === 0
      ? styles.firstTabSelected
      : activeTabIndex === props.pages.length - 1
        ? styles.lastTabSelected
        : '';
  return (
    <div className={styles.plainTabControl}>
      <div
        className={clsx(
          styles.tabBar,
          props.centerButtonText && styles.centerButtonText,
          props.reduceButtonSpacing && styles.reduceButtonSpacing,
        )}
      >
        {props.pages.map((x, index) => (
          <button
            key={index}
            className={
              (index === activeTabIndex ? styles.selected : '') +
              ' aboutUsTypographyHeaderMedium'
            }
            onClick={() => setActiveTabIndex(index)}
          >
            {x.title}
            {x.subtitle && (
              <span className="aboutUsTypographyCaption">{x.subtitle}</span>
            )}
          </button>
        ))}
      </div>
      <div className={`${styles.tabPage} ${tabPageCornerClassName}`}>
        <div className={styles.tabPageInner}>
          {props.pages[activeTabIndex].content}
        </div>
      </div>
    </div>
  );
};

export default PlainTabControl;
